/**
 * Formats a taxonomy database name into a human-readable label.
 *
 * Examples:
 *   "esef_taxonomy_2024" → "ESEF 2024"
 *   "ifrs_taxonomy_2024" → "IFRS 2024"
 *   "dk_gaar_taxonomy_2023" → "DK GAAR 2023"
 */
export const formatTaxonomyName = (name: string): string => {
  const parts = name.split('_');

  // Extract year if the last part is numeric
  const lastPart = parts[parts.length - 1];
  const hasYear = /^\d{4}$/.test(lastPart);

  const year = hasYear ? lastPart : null;
  const nameParts = hasYear ? parts.slice(0, -1) : parts;

  // Drop filler words like "taxonomy"
  const filtered = nameParts.filter((p) => p.toLowerCase() !== 'taxonomy');

  const prefix = filtered.map((p) => p.toUpperCase()).join(' ');

  return year ? `${prefix} ${year}` : prefix;
};
